import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const SearchIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="20" height="20" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.74414 13.3333C3.07393 13.3333 0.0986328 10.3486 0.0986328 6.66667C0.0986328 2.98477 3.07393 0 6.74414 0C10.4143 0 13.3896 2.98477 13.3896 6.66667C13.3896 8.20727 12.8687 9.62582 11.9939 10.7547L16.4691 15.2441L15.2943 16.4226L10.8192 11.9332C9.69386 12.8108 8.27983 13.3333 6.74414 13.3333ZM11.7282 6.66669C11.7282 9.42811 9.49678 11.6667 6.74412 11.6667C3.99146 11.6667 1.75999 9.42811 1.75999 6.66669C1.75999 3.90526 3.99146 1.66669 6.74412 1.66669C9.49678 1.66669 11.7282 3.90526 11.7282 6.66669Z"
        {...svgAttrs}
      />
    </svg>
  );
};

export default SearchIcon;
